var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { onTTI } from '../../time-to-interactive/TimeToInteractive';
import { TIME_TO_INTERACTIVE_EVENT_TYPE } from '../utils/constant';
import { InternalPlugin } from '../InternalPlugin';
export var TTI_EVENT_PLUGIN_ID = 'time-to-interactive';
var TTIPlugin = /** @class */ (function (_super) {
    __extends(TTIPlugin, _super);
    function TTIPlugin(fpsMeasurementEnabled) {
        if (fpsMeasurementEnabled === void 0) { fpsMeasurementEnabled = false; }
        var _this = _super.call(this, TTI_EVENT_PLUGIN_ID) || this;
        _this.handleTTI = function (metric) {
            var ttiEvent = {
                version: '1.0.0',
                value: Math.round(metric.value)
            };
            _this.context.record(TIME_TO_INTERACTIVE_EVENT_TYPE, ttiEvent);
        };
        _this.fpsEnabled = fpsMeasurementEnabled;
        return _this;
    }
    TTIPlugin.prototype.enable = function () {
        /* Nothing to do. */
    };
    TTIPlugin.prototype.disable = function () {
        /* Nothing to do. */
    };
    TTIPlugin.prototype.configure = function () {
        /* Nothing to do. */
    };
    TTIPlugin.prototype.onload = function () {
        onTTI(this.handleTTI, { fpsEnabled: this.fpsEnabled });
    };
    return TTIPlugin;
}(InternalPlugin));
export { TTIPlugin };
